import React from 'react';
import { useHistory } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Grid, Typography } from '@upperhand/playmaker';
import { customerActions } from 'store/actions/dataSources';
import { setRole } from 'utils/auth';

const CustomerSelector = ({ roles }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const onCustomerSelect = async e => {
    const role = roles.find(r => r.customerId === Number(e.target.value));
    setRole(role);
    await dispatch(customerActions.fetchCustomerWithAddress(role.customerId));
    history.push('/');
  };

  return (
    <Grid item container spacing={3} className="form__container">
      <Grid item xs={12}>
        <Typography variant="h6" fullWidth>
          Select customer information below.
        </Typography>
        <select
          className="form__customer-select"
          defaultValue=""
          onChange={onCustomerSelect}
        >
          <option value="" disabled>
            Select customer
          </option>
          {roles.map(role => (
            <option key={role.customerId} value={role.customerId}>
              {role.customerName}
            </option>
          ))}
        </select>
      </Grid>
    </Grid>
  );
};

export default CustomerSelector;
